import { FacilityAddress } from '../hooks/useApi/types'

export const formatFirstFacilityAddressField = (
    address?: FacilityAddress
): string => {
    if (!address) return ''

    const addressParts = [address.address1, address.address2].filter(Boolean)

    return addressParts.join(', ')
}

export const formatSecondFacilityAddressField = (
    address?: FacilityAddress
): string => {
    if (!address) return ''

    const addressParts = [
        address.city,
        address.state,
        address.zip,
        address.country,
    ].filter(Boolean)

    return addressParts.join(', ')
}
